import { render, staticRenderFns } from "./crm-task.vue?vue&type=template&id=75cd13c2&scoped=true&"
import script from "./crm-task.vue?vue&type=script&lang=js&"
export * from "./crm-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd13c2",
  null
  
)

export default component.exports